import { render, staticRenderFns } from "./ModalRequisitions.vue?vue&type=template&id=7221e752&lang=pug&"
import script from "./ModalRequisitions.vue?vue&type=script&lang=js&"
export * from "./ModalRequisitions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports